import { fillString } from '@local_modules/generic/string-template'
import { callApi } from '@local_modules/generic/fetch.js'
import { LOADED_DATA } from './cache-loaded-data.js'
import { enrichLoadedData } from './enrich-loaded-data.js'
import { loadDataAlaSQL } from './alasql.js'
import { targetCurrencySymbol } from './target-currency-symbol.js'
import { addNewEntries } from '@local_modules/generic/arrays/add-new-entries/index.js'
import { analyseDataLoaded } from './analyse-data-loaded.js'
import { analyseDataPrepared } from './analyse-data-prepared.js'

export async function loadOneEntity (accountingOrganisationId, context) {
  console.log('loadOneEntity', accountingOrganisationId)

  // Eliminations are loaded in the loadEliminations function
  if (accountingOrganisationId === 'eliminations') return

  const currencyCode = targetCurrencySymbol(context, accountingOrganisationId)

  const apiEndpoint = '/api/pg-financials/data/:accountingOrganisationId/pg-statement-values/:monthFrom/:monthTo/:currencyCode'
  const url = fillString(apiEndpoint, {
    accountingOrganisationId,
    monthFrom: context.dates?.min,
    monthTo: context.dates?.max,
    currencyCode
  })

  if (LOADED_DATA.has(url)) {
    return LOADED_DATA.get(url)
  }

  const loadedData = await callApi(url)
  console.log('loadDataStatements loadedData', loadedData)
  LOADED_DATA.set(url, loadedData)

  analyseDataLoaded(loadedData)

  enrichLoadedData(loadedData.convertedValuesResults?.chartOfAccounts, loadedData.convertedValuesResults?.convertedValues)
  loadDataAlaSQL(loadedData.convertedValuesResults?.convertedValues)

  storeInContext(context, loadedData)

  analyseDataPrepared(context)

  return loadedData
}

function storeInContext (context, loadedData) {
  // Could analyse that it's no duplicate?
  context.convertedValues = context.convertedValues || []
  context.convertedValues.push(...loadedData.convertedValuesResults?.convertedValues)

  context.chartOfAccounts = context.chartOfAccounts || []
  addNewEntries(context.chartOfAccounts, loadedData?.convertedValuesResults?.chartOfAccounts, 'id')

  context.accountTypes = context.accountTypes || []
  addNewEntries(context.accountTypes, loadedData?.accountTypes, 'accountType')
}
